import { defineStore } from 'pinia'
import { setAVSessionID, removeAVSessionID } from 'src/boot/axios'
import { useCommonStore } from 'src/stores/common'

export const useCustomerStore = defineStore('customer', {
  state: () => ({
    totalRedeemedDollars: 0,
    customer: {},
    coupons: {},
  }),
  actions: {
    async getCustomer() {
      try {
        let { data } = await this.$axiosInstance.get(`/Customer`, {
          params: { global: true },
        })

        if (data.data) {
          // if (
          //   data.data.isBlocked &&
          //   this.$router?.currentRoute?._value?.name != 'Home'
          // ) {
          //   this.$router.push({ name: 'Home' })
          // }
          this.setCustomerDetails(data.data)

          //   commit('SET_CUSTOMER', data.data)
          this.getTotalRedeemableDollars()
        }
      } catch (err) {}
    },

    async mapAgeVerification(eaivPersistedSessionId) {
      try {
        setAVSessionID(eaivPersistedSessionId)
        const { data } = await this.$axiosInstance.post('/AgeVerification/Map')
        if (data.data) {
          this.setCustomerDetails({ isVerifiedOnline: true })
        }
      } catch (error) {
      } finally {
        removeAVSessionID()
      }
    },

    async getTotalRedeemableDollars() {
      try {
        const commonStore = useCommonStore()
        if (
          commonStore.businessConfigurations.lnsSubscriptionType == 2 ||
          (commonStore.businessConfigurations.lnsSubscriptionType == 1 &&
            this.customer.isLoyalty)
        ) {
          let { data } = await this.$axiosInstance.get(
            '/Customer/TotalRedeemableDollars'
          )
          if (
            data?.success &&
            data?.data?.hasOwnProperty('totalRedeemedDollars') &&
            data?.data?.totalRedeemedDollars >= 0
          )
            this.totalRedeemedDollars = data.data.totalRedeemedDollars
        }
      } catch (error) {}
    },

    async GetCoupons(body) {
      try {
        let { data } = await this.$axiosInstance.get(
          `/Customer/Coupons?locationID=${body.locationID}`
        )

        if (data.success && data.data) this.coupons = data.data

        return data
      } catch (error) {
        return error
      }
    },
    setCustomerDetails(payload) {
      this.customer = { ...this.customer, ...payload }
    },
  },
})
